var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7014 3.88451C12.0471 4.64023 11.0001 5.23629 9.95318 5.15114C9.82231 4.12932 10.3349 3.04364 10.9347 2.37307C11.589 1.59606 12.7342 1.04258 13.6612 1C13.7702 2.06439 13.3449 3.1075 12.7014 3.88451ZM13.6502 5.35337C12.1343 5.26822 10.8365 6.19424 10.1168 6.19424C9.38608 6.19424 8.28459 5.39595 7.08495 5.41724C5.52542 5.43853 4.07495 6.30068 3.27882 7.67375C1.64295 10.4199 2.8535 14.4859 4.43484 16.7211C5.20915 17.8281 6.13614 19.0415 7.35759 18.9989C8.51361 18.9563 8.97165 18.2645 10.3676 18.2645C11.7744 18.2645 12.178 18.9989 13.3994 18.9776C14.6645 18.9563 15.4606 17.8707 16.2349 16.7637C17.1183 15.5077 17.4782 14.2836 17.5 14.2198C17.4782 14.1985 15.0571 13.2938 15.0353 10.5689C15.0135 8.2911 16.9438 7.20542 17.031 7.14156C15.9405 5.56625 14.2392 5.39595 13.6502 5.35337Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.811ff0f3367ce31d1186e5b7001b999d.svg";
export { ForwardRef as ReactComponent };